import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

const BACKEND_URL = environment.webapiURL;
@Injectable({ providedIn: "root" })
export class SampleService {
  private data : Record<string, string> = {};
  private dataUpdated = new Subject<Record<string, string>>();

  constructor(private http: HttpClient) {}

  getReportEmbedToken(reportId: string, groupId: string, datasetId: string): void {
    this.http
      .post<{ message: string; Token: Record<string, any> }>(
        BACKEND_URL + "/auth/pbi/getaccesstoken/",
        {
          client_id: environment.azure_ClientId,
          report_id: reportId,
          group_id: groupId,
          dataset_id: datasetId,
        }
      ).subscribe((response) => {
        this.data = {
          accessToken: response.Token.token,
        };
        this.dataUpdated.next(this.data);
      });
  }

  getReportEmbedTokenListener(): Observable<Record<string, string>> {
    return this.dataUpdated.asObservable();
  }
}
